import { useEffect, useState } from 'react';
import { Api } from '../api';



export const useTagsList: () => [Record<string, any>[], boolean] = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        Api.tags.list().then((res) => {
            setData(res.data);
        }).catch(err => {
            console.error(err);
        }).finally(() => {
            setLoading(false);
        })
    }, []);

    return [data, loading];
}